import { render, staticRenderFns } from "./VerticalNavMenuItems.vue?vue&type=template&id=49a1991e&scoped=true"
import script from "./VerticalNavMenuItems.vue?vue&type=script&lang=js"
export * from "./VerticalNavMenuItems.vue?vue&type=script&lang=js"
import style0 from "./VerticalNavMenuItems.vue?vue&type=style&index=0&id=49a1991e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a1991e",
  null
  
)

export default component.exports